import PassengerSSRs from './PassengerSSRs'

export default PassengerSSRs
